
import { 
    GET_HOSPITALS,
    GET_HOSPITALS_SUCCESS,
    GET_HOSPITALS_FAIL, 
    GET_HOSPITALS_RESET,
} from "../actions/getHospitalsAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getHospitalsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_HOSPITALS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_HOSPITALS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_HOSPITALS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_HOSPITALS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getHospitalsReducer;
